import * as ambassadorWixDevcenterBiEventsV1SendBiEventResponse from './devcenter-bi-events-v1-send-bi-event-response-bi-events.http.js';
import * as ambassadorWixDevcenterBiEventsV1SendBiEventResponseTypes from './devcenter-bi-events-v1-send-bi-event-response-bi-events.types.js';
import * as ambassadorWixDevcenterBiEventsV1SendBiEventResponseUniversalTypes from './devcenter-bi-events-v1-send-bi-event-response-bi-events.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function sendBiEvent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDevcenterBiEventsV1SendBiEventResponseUniversalTypes.SendBIEventRequest,
  ambassadorWixDevcenterBiEventsV1SendBiEventResponseTypes.SendBIEventRequest,
  ambassadorWixDevcenterBiEventsV1SendBiEventResponseUniversalTypes.SendBIEventResponse,
  ambassadorWixDevcenterBiEventsV1SendBiEventResponseTypes.SendBIEventResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDevcenterBiEventsV1SendBiEventResponse.sendBiEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bi-event',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SendBIEventResponse as SendBIEventResponseOriginal,
  SendBIEventRequest as SendBIEventRequestOriginal,
  EventName as EventNameOriginal,
  EventNameWithLiterals as EventNameWithLiteralsOriginal,
} from './devcenter-bi-events-v1-send-bi-event-response-bi-events.types.js';
